import React, { createContext, useContext, useState, ReactNode } from 'react'

export interface AssetsProtectionContextValue {
    activePayrollTab: number
    setActivePayrollTab: (tab: number) => void
}

const AssetsProtectionContext = createContext<
    AssetsProtectionContextValue | undefined
>(undefined)

export interface AssetsProtectionProviderProps {
    children: ReactNode
}

export const AssetsProtectionProvider: React.FC<
    AssetsProtectionProviderProps
> = ({ children }) => {
    const [activePayrollTab, setActivePayrollTab] = useState<number>(0)

    const value: AssetsProtectionContextValue = {
        activePayrollTab,
        setActivePayrollTab,
    }

    return (
        <AssetsProtectionContext.Provider value={value}>
            {children}
        </AssetsProtectionContext.Provider>
    )
}

export const useAssetsProtectionContext = (): AssetsProtectionContextValue => {
    const context = useContext(AssetsProtectionContext)
    if (!context) {
        throw new Error(
            'useAssetsProtectionContext must be used within an AssetsProtectionProvider',
        )
    }
    return context
}
